import { useSelector } from "react-redux";
import * as payTypes from './payTypes';

export default function useTickets() {
    const myticket = useSelector(state => ({...state.event.friends.ticket, register_type: state.event.friends.user.register_type, pay: payTypes.PAYTYPE_IPAY}));
    const friendstickets = useSelector(state => [...state.event.friends.friends.map(f => ({...f.ticket, kid: f.kid, pay: f.pay}))]);
    const iamnotattending = useSelector(state => state.event.friends.iamnotattending); 

    return [...(iamnotattending ? [] : [myticket]), ...friendstickets]; 
}